<template>
  <div class="wd-flex" :class="titleLayout === 'horizontal' ? 'wd-flex-wrap wd-items-center wd-gap-2' : 'wd-flex-col wd-gap-1'">
    <div class="wd-flex wd-items-center wd-gap-1">
      <funnow-svg-icon image-path="ai-indicator.svg" max-width="18" />
      <span class="wd-text-base wd-font-bold wd-bg-clip-text wd-text-transparent ai-summary-title-gradient">
        {{ $t('ai_summary_title') }}
      </span>
    </div>

    <div class="wd-flex wd-items-center wd-gap-1">
      <span class="wd-text-base wd-font-bold">{{ subtitle }}</span>
      <v-tooltip
        v-model="isTooltipOpen"
        :open-on-click="isMobile"
        :open-on-hover="!isMobile"
        :location="isMobile ? 'bottom' : 'bottom start'"
        :content-props="{ style: tooltipContentStyle }"
        @click:outside="isTooltipOpen = false"
      >
        <template #activator="{ props: tooltipProps }">
          <div v-bind="tooltipProps" class="wd-cursor-pointer wd-p-1 wd-rounded wd-text-gray80 hover:wd-bg-gray20">
            <funnow-svg-icon image-path="alert-circle-current-color.svg" max-width="16" />
          </div>
        </template>
        <p class="wd-max-w-72 wd-whitespace-pre-line wd-text-sm wd-text-black50">{{ tooltipText }}</p>
      </v-tooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBreakpoints } from '@/composition/useBreakpoints'
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'

interface Props {
  subtitle: string
  tooltipText: string
  titleLayout?: 'horizontal' | 'vertical'
}

withDefaults(defineProps<Props>(), {
  titleLayout: 'horizontal',
})

const { isMobile } = useBreakpoints()

const isTooltipOpen = ref(false)

const tooltipContentStyle = {
  padding: '20px 16px',
  borderRadius: '4px',
  boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.2)',
  backgroundColor: '#fff',
  maxWidth: '288px',
}
</script>

<style scoped>
.ai-summary-title-gradient {
  background-image: linear-gradient(132.13deg, #ffb107 23.88%, #ff5537 76.14%);
}
</style>
